import React, { Fragment } from 'react';
import MedicationReminderIcon from '../assets/icons/medcine_reminder.svg';
import { t } from '../multi-language/multi-lang.service';
function MedicationsTable(_a) {
    var medications = _a.medications;
    var getDays = function (days) {
        var _a;
        if (!days)
            return '';
        if (days.length === 7)
            return t('general_words.days.every');
        return (_a = days === null || days === void 0 ? void 0 : days.split('')) === null || _a === void 0 ? void 0 : _a.map(function (d) { return t("general_words.days.".concat(d)); }).join(' | ');
    };
    var getMedicationRow = function (m, reminderIndex) {
        var reminder = m.reminders[reminderIndex];
        var isFirstMedReminder = reminderIndex === 0;
        var isLastMedReminder = m.reminders.length === 0 || reminderIndex === m.reminders.length - 1;
        return (React.createElement(Fragment, { key: "".concat(reminder === null || reminder === void 0 ? void 0 : reminder.id).concat(m === null || m === void 0 ? void 0 : m.id) },
            React.createElement("tr", { key: "a".concat(reminderIndex), className: "pseudo-tr medication-row-".concat(reminderIndex) }),
            React.createElement("tr", { key: "".concat(reminder === null || reminder === void 0 ? void 0 : reminder.id).concat(m === null || m === void 0 ? void 0 : m.id), className: "".concat(isLastMedReminder && 'last-row') },
                React.createElement("td", { className: 'td-name' }, isFirstMedReminder && m.name),
                React.createElement("td", { className: 'td-dosage' }, isFirstMedReminder && m.dosage),
                React.createElement("td", { className: 'td-times' }, reminder === null || reminder === void 0 ? void 0 : reminder.time),
                React.createElement("td", { className: 'td-frequency' }, getDays(reminder === null || reminder === void 0 ? void 0 : reminder.days)))));
    };
    return (React.createElement("div", { className: 'wrap-medications' },
        React.createElement("table", { className: "table medication-table text-start ".concat(!(medications === null || medications === void 0 ? void 0 : medications.length) && 'empty') },
            React.createElement("thead", null,
                React.createElement("tr", { className: 'header-card' },
                    React.createElement("th", { className: 'td-name' },
                        t('medications.name'),
                        "*"),
                    React.createElement("th", { className: 'td-dosage' }, t('medications.dosage')),
                    React.createElement("th", { className: 'td-times text-capitalize' }, t('general_words.hours')),
                    React.createElement("th", { className: 'td-frequency' }, t('medications.frequency')))),
            React.createElement("tbody", null, (medications === null || medications === void 0 ? void 0 : medications.length) ?
                medications === null || medications === void 0 ? void 0 : medications.map(function (m) {
                    return m.reminders.length ? m.reminders.map(function (_r, i) { return getMedicationRow(m, i); }) : getMedicationRow(m, 0);
                })
                :
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 4, className: 'empty-medication-section' },
                            React.createElement("img", { className: 'mb-2', src: MedicationReminderIcon, alt: 'clock reminder' }),
                            React.createElement("p", null, t('medications.no_medications'))))))));
}
export default MedicationsTable;
//# sourceMappingURL=medications-table.js.map